var moduleMap = {
	"./apiODIN": () => {
		return Promise.all(/* __federation_expose_apiODIN */[__webpack_require__.e(96), __webpack_require__.e(456)]).then(() => (() => ((__webpack_require__(69427)))));
	},
	"./remoteViews": () => {
		return Promise.all(/* __federation_expose_remoteViews */[__webpack_require__.e(644), __webpack_require__.e(96), __webpack_require__.e(456), __webpack_require__.e(78), __webpack_require__.e(564)]).then(() => (() => ((__webpack_require__(86821)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};


// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});